module.exports = __webpack_public_path__ + "img/banner-loja.24a4db57.jpg";